export type MediaType = 'image' | 'video' | 'template' | 'schedule' | 'events';
export type DisplayFit = 'contain' | 'cover';
export type PlaylistMode = 'manual' | 'automatic';

export const ADVERTISEMENT_CATEGORIES = [
  'Fuel Point',
  'Events & Competitions',
  'Memberships & Beginners',
  'Daily Schedule',
  'Branding & Sponsors',
  'General Announcements'
] as const;

export type AdvertisementCategory = typeof ADVERTISEMENT_CATEGORIES[number];

export interface Screen {
  id: string;
  name: string;
  slug: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TemplateContent {
  kind: 'product' | 'event' | 'announcement';
  headline: string;
  supportingText: string;
  productName: string;
  price: string;
  eventTitle: string;
  eventDate: string;
  location: string;
  callToAction: string;
  imageUrl: string;
  qrImageUrl: string;
}

export interface Schedule {
  startDate: string | null;
  endDate: string | null;
  daysOfWeek: number[];
  startTime: string | null;
  endTime: string | null;
  timezone: string;
}

export interface MediaAsset {
  id: string;
  title: string;
  type: MediaType;
  url: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  active: boolean;
  category: AdvertisementCategory;
  schedule: Schedule | null;
  template: TemplateContent | null;
  createdAt: string;
  updatedAt: string;
}

export interface PlaylistItem {
  id: string;
  screenId: string;
  mediaId: string;
  position: number;
  durationSeconds: number;
  active: boolean;
  fit: DisplayFit;
  schedule: Schedule | null;
  createdAt: string;
  updatedAt: string;
}

export interface SmartTimeRule {
  id: string;
  label: string;
  daysOfWeek: number[];
  startTime: string;
  endTime: string;
  categories: AdvertisementCategory[];
  active: boolean;
}

export interface ScreenSettings {
  screenId: string;
  mode: PlaylistMode;
  targetLoopSeconds: number;
  categoryWeights: Record<AdvertisementCategory, number>;
  timeRules: SmartTimeRule[];
  updatedAt: string;
}

export interface ClassSession {
  id: string;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  title: string;
  detail: string;
  location: string;
  active: boolean;
}

export interface TemporarySchedule {
  id: string;
  label: string;
  startDate: string;
  endDate: string;
  sessions: ClassSession[];
}

export interface DisplayEvent {
  id: string; title: string; startDate: string; endDate: string; dateLabel: string; location: string; url: string;
}
export interface EventFeed {
  events: DisplayEvent[]; checkedWeek: string; lastCheckedAt: string; sourceUrl: string;
}

export interface SignageData {
  schemaVersion: 2;
  revision: number;
  screens: Screen[];
  media: MediaAsset[];
  playlistItems: PlaylistItem[];
  screenSettings: ScreenSettings[];
  classSessions: ClassSession[];
  temporarySchedules?: TemporarySchedule[];
  eventFeed?: EventFeed;
}

export type AdminState = SignageData;

export interface DisplayItem extends PlaylistItem {
  media: MediaAsset;
}

export interface DisplayPayload {
  revision: number;
  generatedAt: string;
  screen: Screen;
  mode: PlaylistMode;
  classSessions: ClassSession[];
  temporarySchedules?: TemporarySchedule[];
  eventFeed?: EventFeed;
  items: DisplayItem[];
}
